<template>
  <div>
    <!-- <div class="overlay" v-if="Literacy"></div> -->
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Fund Account</h3>
        <p class="sub-text fnt-14">Use the options below to fund your Smart Stewards wallet</p>
      </div>
    </div>

    <div class="content">
      <h4>Funding Options</h4>
      <div class="links-card-section inv opaque">
        <div class="first-col">
          <img src="@/assets/card.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Fund with Card</p>
          <p class="sub-text">Card Top up coming soon</p>
          <!-- <p class="sub-text">Link your debit card to add funds to your Smart Stewards Wallet
          </p> -->
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo" >
        </div>
      </div>
      <!-- <div class="links-card-section inv" v-if="!showCard" @click="toggle1()">
        <div class="first-col">
          <img src="@/assets/card.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Fund with Card</p>
          <p class="sub-text">Link your debit card to add funds to your Smart Stewards Wallet</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo" >
        </div>
      </div>
      <div class="links-card-outer" v-else>
        <div class="links-card-section inv inner" @click="toggle1()">
          <div class="first-col">
            <img src="@/assets/card.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Fund with Card</p>
          <p class="sub-text">Link your debit card to add funds to your Smart Stewards Wallet</p>
          </div>
          <div class="third-col">
            <img src="@/assets/down-chevron.png" height="6" width="11" alt="Logo">
          </div>
        </div>
        <hr>
        <div class="bank-details">
          <input v-model="amount" placeholder="Enter Amount" type="number"
          class="form-control" required>
          <paystack :class="'btn paystack-btn'" :amount="Number(payAmount)"
      :email="email"
      :paystackkey="paystackKey"
      :reference="reference"
      :callback="callback"
      :close="close"
      :metadata="metadata"
      :embed="false">
      </paystack>
        </div>
      </div> -->
      <!-- <paystack :class="'option'" :amount="payAmount"
      :email="email"
      :paystackkey="paystackKey"
      :reference="reference"
      :callback="callback"
      :close="close"
      :metadata="metadata"
      :embed="false">
      <div class="links-card-section inv">
        <div class="first-col">
          <img src="@/assets/card.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Fund with Card</p>
          <p class="sub-text">Link your debit card to add funds to your Smart Stewards Wallet</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      </paystack> -->

      <div class="links-card-section inv" v-if="!showBank" @click="toggle()">
        <div class="first-col">
          <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Fund with Bank Transfer </p>
          <p class="sub-text">Fund your Smart Stewards wallet by doing a transfer from your Bank
          Account to the account below</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo" >
        </div>
      </div>
      <div class="links-card-outer" v-else>
        <div class="links-card-section inv inner" @click="toggle()">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Fund with Bank Transfer </p>
            <p class="sub-text">Fund your Smart Stewards wallet by doing a transfer from your Bank
            Account to the account below</p>
            <!-- <p class="cabin-family primary bold">** You will be charged processing -->
              <!-- fee of ₦53.75</p> -->
          </div>
          <div class="third-col">
            <img src="@/assets/down-chevron.png" height="6" width="11" alt="Logo">
          </div>
        </div>
        <hr>
        <div class="bank-details">
         <div v-if="checkBvn">
          <p class="bank-detail primary">{{ bank.accountNumber}}</p>
          <p class="bank-detail black">{{ bank.bankName}}</p>
          <p class="account-name semi-bold">MONNIFY/SMART STEWARDS-{{ bank.accountName }}</p>
        </div>
        <div v-else>
          <div v-if="bvnStep === 1">
            <p class="open-sans bold">Generate Account Number</p>
            <p class="secondary">Add and verify your BVN to generate your account number </p>
            <button class="btn primary-btn btn-block open-sans" @click="increase">Add BVN</button>
          </div>

          <div v-else class="text-left">
            <p class="open-sans bold text-center">Verify BVN</p>
            <form>
              <div class="form-group">
                <label class="open-sans bold">BVN</label>
                <input type="number" v-model="bvn" placeholder="BVN" class="form-control"
                required>
              </div>

              <div class="form-group">
                <label class="open-sans bold">Date of Birth</label>
                <input type="date" v-model="dob" class="form-control"
                required>
              </div>
            <button class="btn primary-btn btn-block open-sans" :disabled="isDisabled"
            @click="addBvn"><span v-if="!loading">Verify BVN</span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader></button>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt('success')">
    </success-component>
    <error-component :message="errorMsg" @close="closePrompt('error')" v-if="showError">
    </error-component>
  </div>
</template>

<script>
// import Paystack from 'vue-paystack';
import SuccessComponent from '../components/Success.vue';
import ErrorComponent from '../components/Error.vue';

export default {
  components: {
    // Paystack,
    SuccessComponent,
    ErrorComponent,
  },
  created() {
    this.confirmBvn();
    this.getDetails();
  },
  computed: {
    isDisabled() {
      if (!this.bvn || !this.dob) {
        return true;
      }
      return false;
    },
    reference() {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    email() {
      return this.user.email;
    },
    payAmount() {
      return this.amount * 100;
    },
  },
  data() {
    return {
      showBank: false,
      showCard: false,
      amount: '',
      metadata: {},
      paystackKey: 'pk_live_e2791cf3c1e29e0fa442d18db402eed050fb9459',
      showError: false,
      showSuccess: false,
      errorMsg: '',
      successMsg: '',
      bank: {},
      user: {},
      bvn: '',
      dob: '',
      checkBvn: false,
      bvnStep: 1,
      loading: false,
    };
  },
  methods: {
    getDetails() {
      this.bank = JSON.parse(localStorage.getItem('bank'));
      this.user = JSON.parse(localStorage.getItem('user'));
    },
    async confirmBvn() {
      const url = `${this.$baseUrl}/bvn/check`;
      const res = await this.$http({ url, method: 'GET' });
      this.checkBvn = res.data.checkBvn;
      // console.log(res);
    },
    toggle() {
      if (this.showBank) {
        this.showBank = false;
      } else {
        this.showBank = true;
      }
    },
    toggle1() {
      if (this.showCard) {
        this.showCard = false;
      } else {
        this.showCard = true;
      }
    },
    async addBvn(e) {
      e.preventDefault();
      this.loading = true;
      const data = {
        bvn: this.bvn,
        dob: this.dob,
      };
      try {
        const url = `${this.$baseUrl}/bvn/add`;
        const res = await this.$http({ url, data, method: 'POST' });
        localStorage.setItem('bank', JSON.stringify(res.data.bank));
        this.successMsg = 'Funding account created sucessfully';
        this.showSuccess = true;
        this.confirmBvn();
        this.getDetails();
        this.loading = false;
        setTimeout(() => {
          this.showSuccess = false;
        }, 2500);
      } catch (error) {
        this.loading = false;
        this.errorMsg = error.response.data.message;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 2500);
      }
    },
    showPrompt(prompt) {
      if (prompt === 'success') {
        this.showSuccess = true;
        setTimeout(() => {
          this.$router.push('/');
          this.showSuccess = false;
        }, 2500);
      } else {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 2500);
      }
    },
    async callback(res) {
      console.log(`Payment complete ${res}`);
      const url = `${this.$baseUrl}/wallet/fund`;
      const data = {
        amount: this.amount,
        paymentRef: this.reference,
      };
      try {
        await this.$http({ url, data, method: 'POST' });
        this.showPrompt('success');
      } catch (error) {
        this.showPrompt('error');
        console.log(error);
      }
    },
    close(res) {
      console.log(`Payment closed ${res}`);
    },
    increase() {
      this.bvnStep += 1;
    },
    back() {
      this.$router.go(-1);
    },
    closePrompt(type) {
      if (type === 'error') {
        this.showError = false;
      } else {
        this.getDetails();
        this.showSuccess = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .links-card-outer{
    border-radius: 8px;
    background-color: #FFF;
    margin-bottom: 1rem;
  }
  .sub-text{
    font-size: 12px;
    line-height: 14px;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
  }
  .inner{
    margin-bottom: -1rem;
  }
  .bank-details{
    text-align: center;
    padding: 2rem;
    .bank-detail{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: .25rem;
      font-family: 'Cabin', sans-serif;

    }
  }
  .account-name{
    font-size: 16px;
    color: #6B6B6B;
    font-family: 'Cabin', sans-serif;
  }
  .opaque{
    color: rgba($color: #49566A, $alpha: 0.8)
  }
  .paystack-btn{
    font-family: 'Cabin', sans-serif;
    color: #FFF;
    background-color: #EE0E4C;
    border-color: #EE0E4C;
    border-radius: 8px;
    font-weight: 700;
    margin-top: 1rem;
    font-size: 14px;
  }
</style>
